<template>
    <div class="comapny-offer">
        <company-offer v-if="companyOffers" :companyOffers="companyOffers"></company-offer>
    </div>
</template>

<script>
    import OfferAPI from 'api/OfferAPI'
    import CompanyOffer from 'components/page-elements/company/CompanyOffer'
    import Store from '~/store'

    export default {
        components: { CompanyOffer },
        data() {
            return {
                companyOffers: null,
                companyId: null,
            }
        },

        methods: {
            getOffers() {
                OfferAPI.getPublicCompanyOffersById(this.companyId).then((val) => {
                    this.companyOffers = val
                })
            },
        },

        mounted() {
            this.companyId = Store.getters['data/getSubdomainCompany'].id
            this.getOffers()
        },
    }
</script>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .page-plain {
        margin: 15px;
        @include breakpoint(tablet) {
            padding: 5px;
        }
    }
</style>
